import { render, staticRenderFns } from "./McToastNotifCloseButton.vue?vue&type=template&id=06cae6ca"
var script = {}
import style0 from "./McToastNotifCloseButton.vue?vue&type=style&index=0&id=06cae6ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports